import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'kt-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss']
})
export class ImageModalComponent implements OnInit {

  @Input() imgActualSize;
  @Input() productCode;
  @Input() productName;

	constructor(
		private modalService: NgbModal,

	) { }

  ngOnInit() {
  }

	btnImageClose()
	{
		this.modalService.dismissAll();
	}

}
